<div class="sites-dashboard" title="{{title}}">
  <div class="row">
    <div class="col-md-12">
      <section class="documents">

        <div class="tabs">
          <div [class.active]="tab==='reviews'" (click)="tabClick('reviews')"><span class="isDesktop">Building</span> Reviews</div>
          <div [class.active]="tab==='explorer'" (click)="tabClick('explorer')">Explorer</div>
          @if (hasComplianceAccess) {
            <div [class.active]="tab==='compliance'" (click)="tabClick('compliance')">
            Compliance</div>
          }
        </div>

        <div class="tab-content">
          @if (tab==='reviews') {
            <app-documents-list (onDidLoad)="didLoad($event)"></app-documents-list>
            @if (docCount===0) {
              <p class="text-center" class="no-reports">There are no reports at the
              moment.</p>
            }
          }
          @if (tab==='explorer') {
            <app-explorer></app-explorer>
          }
          @if (tab==='compliance') {
            <app-compliance-home></app-compliance-home>
          }
        </div>

      </section>
    </div>
  </div>

  <div class="row fullscreen-toggle">
    <div class="col-md-12">
      <i class="fa fa-desktop fa-fw pull-right" (click)="toggleFullscreen()"></i>
    </div>
  </div>
  @if (user.role === 'admin') {
    <div routerLink='/status'>status</div>
  }
</div>
